import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { AcknowledgeErrorsTemplate } from 'themes/components';

function AcknowledgeErrors(props) {
    return <AcknowledgeErrorsTemplate {...props} />
}

export default defaultTemplate(AcknowledgeErrors);